import { render, staticRenderFns } from "./RaiseToCasesTask.vue?vue&type=template&id=4e413b0c&scoped=true"
import script from "./RaiseToCasesTask.vue?vue&type=script&lang=ts"
export * from "./RaiseToCasesTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e413b0c",
  null
  
)

export default component.exports